import { useTranslation } from 'react-i18next';

import { SewCreditConsumptionExport } from '@/backoffice/features/data-exports/credit-consumption-export/sew-credit-consumption-export';
import { SewInternalCostCenterExport } from '@/backoffice/features/data-exports/internal-cost-center-export/sew-internal-cost-center-export';
import { SewInternalSapExport } from '@/backoffice/features/data-exports/internal-sap-export/sew-internal-sap-export';
import { PlansExport } from '@/backoffice/features/data-exports/plans-export/plans-export';
import { SewSalesExport } from '@/backoffice/features/data-exports/sales-export/sew-sales-export';
import { SewSapExport } from '@/backoffice/features/data-exports/sap-export/sew-sap-export';
import { ContentLayout } from '@/shared/components/layouts/content-layout/content-layout';
import { CardsGrid } from '@/shared/components/ui/cards-grid/cards-grid.styles';
import { getReseller } from '@/shared/utils/reseller/reseller';

export const DataExports = () => {
  const { t } = useTranslation();
  const isSew = getReseller() === 'sew';

  return (
    <ContentLayout title={t('pages:data_exports')}>
      <CardsGrid>
        <PlansExport />
        {isSew && (
          <>
            <SewSalesExport />
            <SewSapExport />
            <SewInternalSapExport />
            <SewCreditConsumptionExport />
            <SewInternalCostCenterExport />
          </>
        )}
      </CardsGrid>
    </ContentLayout>
  );
};
